import React, { useCallback } from 'react';

import useResource from 'hooks/useResource';

import { ResourceType } from 'services/resources';
import useAdminResource from '../hooks/useAdminResource';

import AdminLayout from 'layouts/Admin.layout';
import FormModal from 'components/FormModal';
import Table from 'components/Table';
import Button from 'components/Button';
import Search from 'components/Search';

import AgencyForm from '../components/forms/Agency.form';
import StatusTag from '../components/Status.tag';
import { EditAction, DeleteAction } from '../components/TableActions';

import { mapLocationsToOptions } from 'helpers/mapToOptions';

const AgenciesPage = () => {
  const locations = useResource(ResourceType.locations, { prefetch: true });
  const agencies = useAdminResource({
    resource: ResourceType.agencies,
    resourceName: 'agency',
    resourceNamePlural: 'agencies',
    searchFields: [
      'name',
      'phone',
      'contact_person',
      'notes',
    ],
  });

  const onAction = useCallback((actionType, item) => {
    switch (actionType) {
      case EditAction.actionType:
        agencies.onEdit(item);
        break

      case DeleteAction.actionType:
        agencies.onDelete(item.agency_id);
        break;

      default: // make eslint happy :)
    }
  }, [agencies]);

  return (
    <AdminLayout
      title="Agencies"
      icon="briefcase"
      extra={[
        <Search
          placeholder={agencies.strings.searchPlaceholder}
          value={agencies.searchVal}
          onChange={value => agencies.search(value)}
        />,
        <Button
          type="primary"
          icon="plus"
          onClick={() => {
            agencies.onCreate({ is_active: 1 });
          }}
        >
          {agencies.strings.addButton}
        </Button>
      ]}
    >
      <FormModal
        title={agencies.strings.formTitle}
        form={agencies.form}
        submitText={agencies.strings.formSubmitButton}
        onClose={() => agencies.form.reset()}
        // width="316px"
        disabledButtons={agencies.form.isSubmitting}
      >
        <AgencyForm
          form={agencies.form}
          locationOptions={mapLocationsToOptions(locations.state.list)}
        />
      </FormModal>
      <Table
        loading={agencies.isLoading || locations.state.isLoading}
        dataSource={agencies.list}
        actions={[
          EditAction,
          DeleteAction,
        ]}
        onAction={onAction}
        actionsProps={{
          resource: 'agency',
        }}
        rowKey="agency_id"
      >
        <Table.Column title="ID" dataIndex="agency_id" />
        <Table.Column title="Name" dataIndex="name" />
        <Table.Column title="Contact Person" dataIndex="contact_person" />
        <Table.Column title="Phone Number" align="center" dataIndex="phone" />
        <Table.Column title="Email" dataIndex="email" />
        <Table.Column title="Status" dataIndex="is_active" align="center" render={isActive => {
          return isActive === true || isActive === 1 ? <StatusTag isActive={isActive} /> : null;
        }} />
        <Table.Column title="Notes" dataIndex="notes" />
      </Table>
    </AdminLayout>
  );
};

export default AgenciesPage;
